import React from 'react';
import { Printer, Settings } from 'lucide-react';

const ConfiguredPrintersCard = ({
  printers,
  loading,
  onTestPrinter,
  onConfigurePrinter
}) => {
  if (loading) {
    return (
      <div className="animate-pulse space-y-4">
        {[1, 2].map((i) => (
          <div key={i} className="bg-gray-100 dark:bg-gray-700 rounded-lg p-4 h-24" />
        ))}
      </div>
    );
  }

  if (!printers?.length) {
    return (
      <div className="col-span-2 flex flex-col items-center justify-center py-8 text-center">
        <Printer className="w-12 h-12 text-gray-400 mb-3" />
        <p className="text-gray-500 dark:text-gray-400">
          No hay impresoras configuradas
        </p>
      </div>
    );
  }

  return (
    <>
      {printers.map(printer => (
        <div 
          key={printer.id}
          className="bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 transition-colors"
        >
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-sm font-medium text-gray-900 dark:text-white truncate">
                  {printer.name}
                </h3>
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                  printer.status === 'online' 
                    ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400' 
                    : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-400'
                }`}>
                  {printer.status === 'online' ? 'Conectada' : 'Desconectada'}
                </span>
              </div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">
                IP: {printer.ip_address}
              </p>
              <div className="flex flex-wrap gap-1">
                {printer.types.map(type => (
                  <span 
                    key={type}
                    className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400"
                  >
                    {type === 'delivery' && 'Delivery'}
                    {type === 'fulfillment' && 'Preparación'}
                    {type === 'backup' && 'Copia'}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex gap-2 ml-4">
              <button
                onClick={() => onTestPrinter(printer.id)}
                className="p-1.5 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                title="Probar impresora"
              >
                <Printer className="w-4 h-4" />
              </button>
              <button
                onClick={() => onConfigurePrinter(printer)}
                className="p-1.5 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
                title="Configurar impresora"
              >
                <Settings className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ConfiguredPrintersCard; 